import React from 'react';

import Button from 'components/partials/button/button';

import Icons from 'assets/icons';

interface GoalLike {
  summary?: string;
  [key: string]: unknown;
}

interface CellInfo<T = unknown> {
  renderValue: () => T;
  getValue: () => T;
}

interface CriticalElementColumn {
  id: string;
  accessorKey: string;
  header: () => React.JSX.Element;
  cell: (info: CellInfo) => React.JSX.Element;
  headerClassName: string;
  className: string;
  enableSorting: boolean;
  isHeaderCentered?: boolean;
}

const commonStyles = 'pl-4 border-r-2 border-white font-semibold h-12';

export const getCriticalElementsTableSettings = (
  handleViewDetails: (id: string | number) => void,
  _clientId?: string | number,
  _selectedYear?: string | number
): CriticalElementColumn[] => [
  {
    id: 'summary',
    accessorKey: 'summary',
    header: () => <span>CRITICAL ELEMENT</span>,
    cell: (info) => <span>{info.renderValue() as React.ReactNode}</span>,
    headerClassName: `${commonStyles} rounded-tl-md rounded-bl-md`,
    className: 'pl-4 py-3 tablet:w-[30%] font-semibold',
    enableSorting: false,
  },
  {
    id: 'relatedGoals',
    accessorKey: 'goals',
    header: () => <span>RELATED GOALS</span>,
    cell: (info) => {
      const goals = (info.getValue() as GoalLike[] | undefined) || [];

      if (goals.length === 0) {
        return <span className="w-full text-gray-600">No goals linked</span>;
      }

      return (
        <div className="flex flex-wrap gap-2">
          {goals.map((goal, index) =>
            goal.summary ? (
              <div
                key={index}
                className="inline-block px-2 leading-5 py-1 rounded-md text-sm text-gray-700 border border-navy-200"
              >
                {goal.summary}
              </div>
            ) : null
          )}
        </div>
      );
    },
    headerClassName: `${commonStyles}`,
    className: 'pl-4 py-3 tablet:w-[45%]',
    enableSorting: false,
  },
  {
    id: 'actions',
    accessorKey: 'id',
    header: () => <span>ACTION</span>,
    isHeaderCentered: true,
    cell: (info) => (
      <div className="flex justify-center">
        <Button
          variant="reserve-outlined"
          size="sm"
          iconBefore={<Icons.Eye aria-label="EyeIcon" />}
          className="text-xs md:text-sm"
          onClick={() => handleViewDetails(info.getValue() as string | number)}
        >
          View Details
        </Button>
      </div>
    ),
    headerClassName: `${commonStyles} rounded-tr-md rounded-br-md`,
    className: 'pl-4 py-3 tablet:w-[15%]',
    enableSorting: false,
  },
];
